// TODO:
// interface: Product
// type: MembershipSubscriptionProduct
// type: CourseAddonProduct | MembershipAddonProduct

type CourseRegMeta = {
  id: string, // course reg id
  courseSlug: string,
  courseName: string,
}

export type Product = {
  type: ProductType,
  planId: string, // TODO: change to generic
  billingPeriod: number,
  billingPeriodUnit: PeriodUnit,
  freeTrialPeriod: number | null, // rename: trialPeriod
  freeTrialPeriodUnit: PeriodUnit,
  price: number, // in decimal
  basePrice: number, // in decimal
  trialPrice: number, // in decimal
  currencyCode: string, // 3 letter ISO code in lowercase
  currencySymbol: string,
  billingCountry: string,
  expiryPeriod: number | null, // expects 1 for onetime purchase addons
  expiryPeriodUnit: PeriodUnit, // expects day for onetime purchase addons
  courseRegMeta?: CourseRegMeta,
  customAttributes?: CustomAttributes,
}

export type CustomAttributes = {
  [key: string]: string,
}

// TODO:
// separate SUBSCRIPTION type & introduce specific mock data
export enum ProductType {
  MOCK_DATA, // indicates initial placeholder data
  SUBSCRIPTION, // indicates addons or subscription plans
  UPDATE_PAYMENT_METHOD, // indicates card update
}

export enum PeriodUnit {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  NEVER = 'never',
}

export enum DiscountSource {
  OFFER_TYPE,
  USER_COUPON,
  UPGRADE_COUPON,
}

export type Discount = {
  source: DiscountSource,
  coupon: Coupon,
}

export enum DiscountType {
  PERCENTAGE,
  FIXED_AMOUNT,
};

export type Coupon = {
  currencyCode: string,
  currencySymbol: string,
  discountType: DiscountType,
  recurring: boolean,
  amount?: number,
  discountPercentage?: number,
  couponCode: string,
}

export enum LifetimePlanType {
  BASIC = 'basic',
  FACULTY = 'faculty',
  UNLIMITED = 'unlimited',
  STANDARD = 'standard',
}
